export enum NaryTreeTraversalOrder {
    PreOrder = 'PreOrder',
    PostOrder = 'PostOrder'
}

export enum AlgorithmModes {
    Flush = 'flush',
    Adaptive = 'adaptive'
}

export enum ChildrenProperties {
    components = 'components',
    hiddenComponents = 'hiddenComponents',
    backgroundComponents = 'backgroundComponents',
    innerElements = 'innerElements'
}

export enum Orientation {
    Horizontal = 'horizontal',
    Vertical = 'vertical'
}

export enum StageName {
    COMPONENT_CATEGORIZATION = 'COMPONENT_CATEGORIZATION',
    GROUPING = 'GROUPING',
    GROUPING_ORDER = 'GROUPING_ORDER',
    INIT_CSS_MODELS = 'INIT_CSS_MODELS',
    POSITION = 'POSITION',
    STRUCTURE_ORDER = 'STRUCTURE_ORDER',
    HORIZONTAL_LAYOUT_SCALE = 'HORIZONTAL_LAYOUT_SCALE',
    VERTICAL_LAYOUT_SCALE = 'VERTICAL_LAYOUT_SCALE',
    TRANSFORM_STYLE = 'TRANSFORM_STYLE',
    POST_PROCESS = 'POST_PROCESS'
}

export enum SkipPredicate {
    INVALID_FOR_GROUPING = 'invalidForGrouping',
    SHOULD_HALT_ALGO = 'shouldHaltAlgorithm'
}

export enum VirtualStructureTag {
    Virtual = 'virtual',
    Real = 'real'
}

export enum StructureIteratorAction {
    Stop = 'stop'
}
